import React, { useState } from 'react'
import SiteGrid from "../ui/SiteGrid"
import SquareGrid from "../ui/SquareGrid"
import { doctorsArray } from "app/data/teamData"
import IconContainer from "../ui/IconContainer"

export default function OurTeam() {

  const [activeTeam, setActiveTeam] = useState(0)

  const teamRender = doctorsArray?.map((team, index) => {
    return <div
      className={`team-item ${activeTeam === index ? 'show' : ''}`}
      key={index}
    >
      <h4>{team.name}</h4>
      <h6>{team.position}</h6>
      <p>{team.description}</p>
    </div>
  })

  const teamImgsRender = doctorsArray?.map((team, index) => {
    return <img
      key={index}
      src={team.img}
      alt={team.name}
      className={activeTeam === index ? 'show' : ''}
    />
  })

  return (
    <>
      <div className="team-title-section">
        <SiteGrid className="titles-flex">
          <h6 className="title">Our Team</h6>
          <h2 className="title">The Experts Behind Our Quality Care</h2>
        </SiteGrid>
      </div>
      <div className="team-section home-section">
        <SiteGrid className="team-flex">
          <div className="img-container">
            {teamImgsRender}
          </div>
        </SiteGrid>
        <div className="text-container">
          {teamRender}
          <div className="nav-container">
            <IconContainer
              icon="fal fa-arrow-left"
              iconSize={20}
              dimensions={35}
              iconColor="#fff"
              onClick={() => setActiveTeam(activeTeam === 0 ? doctorsArray.length - 1 : activeTeam - 1)}
            />
            <IconContainer
              icon="fal fa-arrow-right"
              iconSize={20}
              dimensions={35}
              iconColor="#fff"
              onClick={() => setActiveTeam(activeTeam === doctorsArray.length - 1 ? 0 : activeTeam + 1)}
            />
          </div>
          <div className="circle circle-1" />
          <SquareGrid color="#fff" />
        </div>
        <div className="circle circle-2" />
        <SquareGrid
          className="square-grid-2"
        />
      </div>
    </>
  )
}
